import { User } from '@app/models';
import { SharedObjectType } from '@app/pcs/reducer/share-filter-label';
import { Action } from '@ngrx/store';

export interface ShareObjectPayload {
  sharedObjectId: number;
  sharedObjectType: SharedObjectType;
}

export enum ShareFilterLabelActionTypes {
  ShareWithUsers = '[FilterLabelShare] Share With Users',
  ShareWithUsersSuccess = '[FilterLabelShare] Share With Users Success',
  ShareWithUsersFail = '[FilterLabelShare] Share With Users Fail',

  InitShareForm = '[FilterLabelShare] Init Share Form',
  SetSharedObject = '[FilterLabelShare] Set Shared Object',
  ToggleShareForm = '[FilterLabelShare] Toggle Share Form',

  FetchEligibleUsersForSharing = '[FilterLabelShare] Fetch Eligible Users For Sharing',
  FetchEligibleUsersForSharingSuccess = '[FilterLabelShare] Fetch Eligible Users For Sharing Success',
  FetchEligibleUsersForSharingFail = '[FilterLabelShare] Fetch Eligible Users For Sharing Fail',

  FetchSharedUsers = '[FilterLabelShare] Fetch Shared Users',
  FetchSharedUsersSuccess = '[FilterLabelShare] Fetch Shared Users Success',
  FetchSharedUsersFail = '[FilterLabelShare] Fetch Shared Users Fail',

  ResetState = '[FilterLabelShare] Reset State'
}


export class ShareWithUsers implements Action {
  readonly type = ShareFilterLabelActionTypes.ShareWithUsers;

  constructor(public payload: number[]) {
  }
}

export class ShareWithUsersSuccess implements Action {
  readonly type = ShareFilterLabelActionTypes.ShareWithUsersSuccess;
}

export class ShareWithUsersFail implements Action {
  readonly type = ShareFilterLabelActionTypes.ShareWithUsersFail;

  constructor(public payload: Error) {
  }
}

export class SetSharedObject implements Action {
  readonly type = ShareFilterLabelActionTypes.SetSharedObject;

  constructor(public payload: ShareObjectPayload) {
  }
}

export class ToggleShareForm implements Action {
  readonly type = ShareFilterLabelActionTypes.ToggleShareForm;
}

export class InitShareForm implements Action {
  readonly type = ShareFilterLabelActionTypes.InitShareForm;

  constructor(public payload: ShareObjectPayload) {
  }
}

export class FetchEligibleUsersForSharing implements Action {
  readonly type = ShareFilterLabelActionTypes.FetchEligibleUsersForSharing;

  constructor(public payload: ShareObjectPayload) {
  }
}

export class FetchEligibleUsersForSharingSuccess implements Action {
  readonly type = ShareFilterLabelActionTypes.FetchEligibleUsersForSharingSuccess;

  constructor(public payload: User[]) {
  }
}

export class FetchEligibleUsersForSharingFail implements Action {
  readonly type = ShareFilterLabelActionTypes.FetchEligibleUsersForSharingFail;

  constructor(public payload: Error) {
  }
}

export class FetchSharedUsers implements Action {
  readonly type = ShareFilterLabelActionTypes.FetchSharedUsers;

  constructor(public payload: ShareObjectPayload) {
  }
}

export class FetchSharedUsersSuccess implements Action {
  readonly type = ShareFilterLabelActionTypes.FetchSharedUsersSuccess;

  constructor(public payload: User[]) {
  }
}

export class FetchSharedUsersFail implements Action {
  readonly type = ShareFilterLabelActionTypes.FetchSharedUsersFail;

  constructor(public payload: Error) {
  }
}

export class ResetState implements Action {
  readonly type = ShareFilterLabelActionTypes.ResetState;
}

export type ShareFilterLabelActions =
  | ShareWithUsers
  | ShareWithUsersSuccess
  | ShareWithUsersFail
  | InitShareForm
  | SetSharedObject
  | ToggleShareForm
  | FetchEligibleUsersForSharing
  | FetchEligibleUsersForSharingSuccess
  | FetchEligibleUsersForSharingFail
  | FetchSharedUsers
  | FetchSharedUsersSuccess
  | FetchSharedUsersFail
  | ResetState;
